import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Member from "../components/Common/Member";
import PrivateRoute from "./PrivateRoute";
import Resetpassword from "../pages/static/ResetPassword";
import PageNotFound from "../pages/static/en/PageNotFound";
import Personalpage from "../pages/static/en/Personalpage";
import UserVerification from "../pages/static/en/UserVerification";
import MakeNewPassword from "../pages/static/en/MakeNewPassword";
// import Sidebar from "../pages/static/en/Sidebar";
import AddCompany2 from "../pages/dynamic/AddCompany2";
import AddContacts from "../pages/dynamic/AddContact";
import AddCompany from "../pages/dynamic/AddCompany";
import AddMember from "../pages/dynamic/AddMember";
import AddProject from "../pages/dynamic/AddProject";
import AddPurchasingOrder from "../pages/dynamic/AddPurchasingOrder";
import Bookkeeping from "../pages/dynamic/Bookkeeping";
import ContactList from "../pages/dynamic/ContactList";
import TeamMember from "../pages/dynamic/MemberList";
import PlanBoard from "../pages/dynamic/PlanBoard";
import ProductsList from "../pages/dynamic/ProductsList";
import Personal from "../pages/dynamic/Profilepage";
import Project from "../pages/dynamic/Project";
import Settings from "../pages/dynamic/Settings";
import AddScreenLabels from "../pages/dynamic/AddScreenLabels";
import UpdateMember from "../pages/dynamic/UpdateMember";
import UpdateProject from "../pages/dynamic/UpdateProject";
import InterkoPage from "../pages/poc-interko/interko";
// import Addsupplier from "../pages/dynamic/AddSupplier";

// import PlanBoard from "../pages/dynamic/PlanBoard";
import Addsupplier from "../pages/dynamic/AddSupplier";
import AddToWareHouseProject from "../pages/dynamic/AddToWareHouseProject";
import AdvanceItemPurchasing from "../pages/dynamic/AdvanceItemPurchasing";
import ConfirmPurchasingOrder from "../pages/dynamic/ConfirmPurchasingOrder";
import CountStockSingle from "../components/StockLevels/CountStockSingle";
import EquipmentDetails from "../pages/dynamic/EquipmentDetails";
import EquipmentList from "../pages/dynamic/EquipmentList";
import FinancialCostDetails from "../pages/dynamic/FinancialCostDetails";
import JustInTimePurchasing from "../pages/dynamic/JustInTimePuchasing";
import OrderPicking from "../pages/dynamic/OrderPicking";
import Quote from "../pages/dynamic/Quote";
import PurchaseOrder from "../pages/dynamic/PurchaseOrder";
import QuoteCalculation from "../pages/dynamic/QuoteCalculation";
import QuoteNew from "../pages/dynamic/quoteNew";
import Report from "../pages/dynamic/Report";
import Settings2 from "../pages/dynamic/Settings2";
import Stock from "../pages/dynamic/Stock";
import SupplierList from "../pages/dynamic/Supplierlist";
import ViewPurchasingOrder from "../pages/dynamic/ViewPurchasingOrder";
import ViewRentOrder from "../pages/dynamic/ViewRentOrder";
import Worktime from "../pages/dynamic/Worktime";
import QuotePdf from "../pages/dynamic/QuotePdf";
import POPage from "../pages/dynamic/POPage";
import Proforma from "../pages/dynamic/Proforma";
import InvoicesSettings from "../pages/dynamic/InvoicesSettings";
import InvoiceAllList from "../pages/dynamic/InvoiceAllList";
import NewInvoice from "../pages/dynamic/NewInvoice";
import UpdateInvoice from "../pages/dynamic/UpdateInvoice";
import Teams from "../pages/dynamic/Teams";
import CreditNote from "../pages/dynamic/CreditNote";
import ProductStockEntry from "../components/StockLevels/ProductStockEntry";
import ProductStockOut from "../components/StockLevels/ProductStockOut";
import OrderPickingList from "../pages/dynamic/OrderPickingList";
import CountStockList from "../components/StockLevels/CountStockList";
import CountStockReport from "../components/StockLevels/CountStockReport";
import AddProduct from "../components/AddProduct/AddProduct";
import ProvisionalDetails from "../pages/dynamic/ProvisionalDetails";
import NewFacility from "../components/Assets/NewFacility";
import Equipment from "../components/Assets/Equipment";
import Part from "../components/Assets/Part";
import Assets from "../pages/dynamic/Assets";
import DashBoard from "../pages/dynamic/DashBoard";
import ViewPurchasingOrderAssets from "../components/Assets/Purchasing/ViewPurchasingOrderAssets";
import { WorkOrders } from "../components/Assets/WorkOrders/workOrders";
import ViewPurchaseOrderWithQuotes from "../pages/dynamic/ViewPurchaseOrderWithQuotes";
import SettingsPlanboard from "../pages/dynamic/SettingsPlanboard";
import MyPlan from "../pages/dynamic/MyPlan";
import FormsPOC from "../components/Form_Builder_POC/FormsPOC";
import FormBuilderPOC from "../components/Form_Builder_POC/FormBuilderPOC";
import FormBuilderPOC2 from "../components/Form_Builder_POC/FormBuilderPOC2";
import ChatWidget from "../components/ChatWidget/adminPanel/ChatWidget";
import OcrForm from "../pages/dynamic/ocr/ocrform";
import OcrList from "../pages/dynamic/ocr/ocrlist";
import CompanyList from "../pages/dynamic/CompanyList";
import SpireConnect from "../pages/dynamic/SpireConnect";
import TemplateBuilder from "../pages/dynamic/TemplateBuilder";
import GenericTemplateBuilder from "../components/TemplateBuilder/GenericTemplateBuilder";
import StockAuthorization from "../pages/dynamic/StockAuthorization";
import WorkflowAutomationDashboard from "../components/WorkflowAutomation/WorkflowAutomationDashboard";
import AddWorkflowAutomation from "../components/WorkflowAutomation/AddWorkflowAutomation";
import QuoteProductService from "../pages/dynamic/QuoteProductService";
import AddRentOrder from "../pages/dynamic/AddRentOrder";
import QuotePdfNew from "../pages/dynamic/QuotePdfNew";
import MvpNewView from "../pages/dynamic/MvpNewView";
import MvpNewTaskDetails from "../pages/dynamic/MvpNewTaskDetails";
import MvpNewTrack from "../pages/dynamic/MvpNewTrack";
import Schedule from "../pages/dynamic/Schedule";
import MaterialsSubList from "../components/Add_Project/MaterialsSubList";
import ViewMaterialsSubList from "../components/Add_Project/ViewMaterialsSubList";
import Payroll from "../pages/dynamic/Payroll";
import OffCyclePayroll from "../pages/dynamic/OffCyclePayroll";
import EditPayroll from "../pages/dynamic/PayrollEdit";
import PayrollTimeSheet from "../pages/dynamic/payrollTimeSheet";
import PayrollStatus from "../pages/dynamic/PayrollStatus";
import ReturnToWarehouseSingle from "../pages/dynamic/ReturnToWarehouseSingle";
import ReturnToWarehouseList from "../pages/dynamic/ReturnToWarehouseList";
import ProjectOrderPickingList from "../pages/dynamic/ProjectOrderPickingList";
import OrderPickingPOListMobile from "../pages/dynamic/OrderPickingPOListMobile";
import OrderPickingProjectListMobile from "../pages/dynamic/OrderPickingProjectListMobile";
import OrderPickingFromProject from "../pages/dynamic/OrderPickingFromProject";
import ProjectKanban from "../pages/dynamic/ProjectKanban";
import ShowTimerActivity from "../utils/timerActivity/ShowTimerActivity";
import SpireAi from "../components/Common/SpireAI/SpireAi";
import SpireAiUpdate from "../components/Common/SpireAI/SpireAiUpdate";
import ToDoList from "../pages/dynamic/ToDoList";
import PaymentExpired from "../pages/static/en/PaymentExpired";
import Notifications from "../pages/dynamic/Notifications";
import GrapesTemplateBuilder from "../components/GrapesTemplateBuilder/GrapesTemplateBuilder";

const Routering = () => {
  return (
    <>
      <Switch>
        {/* <Route exact path="/" component={Loginscreen} /> */}
        {/* <Route exact path="/resetpassword/:userid" component={Resetpassword} /> */}
        {/* <Route exact path="/landingpage" component={memberpage} /> */}
        <PrivateRoute exact path="/personalpage" component={Personalpage} />
        <PrivateRoute
          exact
          path="/order-picking-PO-items-mobile"
          component={OrderPickingPOListMobile}
        />
        <PrivateRoute
          exact
          path="/order-picking-items-mobile"
          component={OrderPickingProjectListMobile}
        />
        <PrivateRoute
          exact
          path="/project-order-picking-list"
          component={ProjectOrderPickingList}
        />
        <PrivateRoute exact path="/planboard/:taskId?" component={PlanBoard} />
        <PrivateRoute
          exact
          path="/planboard/task/:taskIds?"
          component={PlanBoard}
        />
        {/* <Route exact path="/personalpage" component={Personalpage} /> */}
        <PrivateRoute exact path="/profile" component={Personal} />
        <PrivateRoute exact path="/dashboard" component={DashBoard} />
        <PrivateRoute exact path="/teamconnect" component={Member} />
        <PrivateRoute exact path="/payroll" component={Payroll} />
        <PrivateRoute
          exact
          path="/off-cycle-payroll"
          component={OffCyclePayroll}
        />
        <PrivateRoute exact path="/edit-payroll" component={EditPayroll} />
        <PrivateRoute exact path="/payroll-status" component={PayrollStatus} />
        <PrivateRoute
          exact
          path="/view-payroll-time-sheet"
          component={PayrollTimeSheet}
        />
        <Route exact path="/forgetpassword/:userid" component={Resetpassword} />
        {/* <Route exact path="/UserVerification/:userid" component={UserVerification} /> */}
        {/* <Route exact path="/MakeNewPassword/:userid" component={MakeNewPassword} /> */}
        <PrivateRoute exact path="/chat" component={ChatWidget} />
        <PrivateRoute exact path="/add-member" component={AddMember} />
        <PrivateRoute exact path="/settings" component={Settings2} />
        <PrivateRoute
          exact
          path="/settings-planboard"
          component={SettingsPlanboard}
        />
        <PrivateRoute exact path="/settings-language" component={Settings} />
        <PrivateRoute exact path="/settings-language" component={Settings} />
        <PrivateRoute
          exact
          path="/add-screen-labels"
          component={AddScreenLabels}
        />
        <PrivateRoute exact path="/project" component={Project} />
        <PrivateRoute exact path="/stock" component={Stock} />
        <PrivateRoute exact path="/stock-materials" component={Stock} />
        <PrivateRoute exact path="/my-task" component={MvpNewView} />
        <PrivateRoute
          exact
          path="/my-task/:taskId"
          component={MvpNewTaskDetails}
        />
        <PrivateRoute
          exact
          path="/task-track/:taskId"
          component={MvpNewTrack}
        />
        <PrivateRoute exact path="/productsList" component={ProductsList} />

        <PrivateRoute exact path="/addProject" component={AddProject} />
        <PrivateRoute
          exact
          path="/financial-cost-details"
          component={FinancialCostDetails}
        />
        <PrivateRoute
          exact
          path="/project/:id/:code?/:tab?"
          component={UpdateProject}
        />
        <PrivateRoute exact path="/add-contact" component={AddContacts} />
        <PrivateRoute exact path="/bookkeeping" component={Bookkeeping} />
        {/* <PrivateRoute exact path="/add-purchasing-order" component={AddPurchasingOrder} /> */}
        <PrivateRoute
          exact
          path="/add-purchasing-order/:jitOrder?/:productPartsupplierCode?/:productPartCode?"
          component={AddPurchasingOrder}
        />
        <PrivateRoute exact path="/add-rent-order" component={AddRentOrder} />
        <PrivateRoute
          exact
          path="/view-purchasing-order/:orderCode"
          component={ViewPurchasingOrder}
        />
        <PrivateRoute
          exact
          path="/order-picking-project"
          component={OrderPickingFromProject}
        />
        <PrivateRoute
          exact
          path="/view-rent-order/:orderCode"
          component={ViewRentOrder}
        />

        <PrivateRoute
          exact
          path="/view-purchasing-order-assets"
          component={ViewPurchasingOrderAssets}
        />
        <PrivateRoute
          exact
          path="/view-purchasing-order-assets/:orderCode"
          component={ViewPurchasingOrderAssets}
        />
        <PrivateRoute exact path="/order-picking" component={OrderPicking} />
        <PrivateRoute
          exact
          path="/return-to-warehouse-single"
          component={ReturnToWarehouseSingle}
        />
        <PrivateRoute
          exact
          path="/return-to-warehouse-list"
          component={ReturnToWarehouseList}
        />
        <PrivateRoute exact path="/worktime" component={Report} />
        <PrivateRoute exact path="/quote" component={Quote} />
        <PrivateRoute exact path="/quote/:quoteid/pdf" component={QuotePdf} />
        {/* <PrivateRoute
                    exact
                    path="/quote/:quoteId/pdf"
                    component={QuotePdfNew}
                /> */}
        <PrivateRoute
          exact
          path="/quote/:purchaseOrderID/purshase-order"
          component={PurchaseOrder}
        />
        <PrivateRoute
          exact
          path="/quote/:purchaseOrderID/purshase-order/:quotesId"
          component={ViewPurchaseOrderWithQuotes}
        />
        <PrivateRoute exact path="/quote/:quoteId" component={QuoteNew} />
        <PrivateRoute
          exact
          path="/quote/:quoteId/product-and-service"
          component={QuoteProductService}
        />
        <PrivateRoute
          exact
          path="/quote-calculation"
          component={QuoteCalculation}
        />
        <PrivateRoute exact path="/tracking" component={Worktime} />
        <PrivateRoute exact path="/asset-management" component={Assets} />
        <PrivateRoute
          exact
          path="/asset-management/update-facility"
          component={NewFacility}
        />
        <PrivateRoute
          exact
          path="/asset-management/update-equipment"
          component={Equipment}
        />
        <PrivateRoute
          exact
          path="/asset-management/update-part"
          component={Part}
        />
        {/* <PrivateRoute
          exact
          path="/asset-management/work/:MaintenanceID?"
          component={Part}
        /> */}
        <PrivateRoute
          exact
          path="/asset-management/newfacility"
          component={NewFacility}
        />
        <PrivateRoute
          exact
          path="/asset-management/equipment"
          component={Equipment}
        />
        <PrivateRoute exact path="/asset-management/part" component={Part} />
        <PrivateRoute exact path="/work-orders" component={WorkOrders} />
        <Route exact path="/request-po" component={POPage}></Route>
        <Route exact path="/proforma" component={Proforma}></Route>
        <PrivateRoute
          exact
          path="/contactlist/add-company"
          component={AddCompany2}
        />
        <PrivateRoute
          exact
          path="/contactlist/add-company/:id"
          component={AddCompany2}
        />
        <PrivateRoute
          exact
          path="/contactlist/edit-contact/:id"
          component={AddContacts}
        />
        <PrivateRoute exact path="/add-company" component={AddCompany} />
        <PrivateRoute exact path="/add-company/:id" component={AddCompany} />
        <PrivateRoute
          exact
          path="/updat-member/:userid/:projectId?/:projectHiringId?"
          component={UpdateMember}
        />
        <PrivateRoute exact path="/member-list" component={TeamMember} />
        <PrivateRoute exact path="/contact-list" component={ContactList} />
        <PrivateRoute exact path="/interko" component={InterkoPage} />
        <PrivateRoute exact path="/supplier-list" component={SupplierList} />
        <PrivateRoute exact path="/add-supplier" component={Addsupplier} />
        <PrivateRoute
          exact
          path="/supplierlist/add-supplier/:id"
          component={Addsupplier}
        />
        <PrivateRoute
          exact
          path="/supplierlist/edit-supplier/:id"
          component={Addsupplier}
        />

        <PrivateRoute
          exact
          path="/add-to-warehouse-project"
          component={AddToWareHouseProject}
        />
        <PrivateRoute
          exact
          path="/confirm-purchasing-order/:orderCode"
          component={ConfirmPurchasingOrder}
        />
        <PrivateRoute
          exact
          path="/stock-levels-single"
          component={CountStockSingle}
        />
        <PrivateRoute
          exact
          path="/stock-levels-list"
          component={CountStockList}
        />
        <PrivateRoute
          exact
          path="/stock-levels-report"
          component={CountStockReport}
        />
        <PrivateRoute exact path="/settings-2" component={Settings2} />
        <PrivateRoute
          exact
          path="/advance-item-purchasing"
          component={AdvanceItemPurchasing}
        />
        <PrivateRoute exact path="/equipment" component={EquipmentList} />
        <PrivateRoute
          exact
          path="/equipment-details"
          component={EquipmentDetails}
        />
        <PrivateRoute
          exact
          path="/equipment-details/:id"
          component={EquipmentDetails}
        />
        <PrivateRoute
          exact
          path="/just-in-time-purchasing"
          component={JustInTimePurchasing}
        />
        <PrivateRoute
          exact
          path="/invoices-settings"
          component={InvoicesSettings}
        />

        <PrivateRoute exact path="/invoices" component={InvoiceAllList} />
        <PrivateRoute exact path="/NewInvoice" component={NewInvoice} />
        <PrivateRoute exact path="/UpdateInvoice" component={UpdateInvoice} />
        <PrivateRoute exact path="/Teams" component={Teams} />
        <PrivateRoute exact path="/Schedule" component={Schedule} />
        <PrivateRoute exact path="/CreditNote" component={CreditNote} />
        <PrivateRoute exact path="/InvoiceAllList" component={InvoiceAllList} />
        <PrivateRoute
          exact
          path="/product-stock-entry"
          component={ProductStockEntry}
        />
        <PrivateRoute
          exact
          path="/product-stock-out"
          component={ProductStockOut}
        />
        <PrivateRoute
          exact
          path="/OrderPickingList"
          component={OrderPickingList}
        />
        <PrivateRoute
          exact
          path="/ProvisionalDetails"
          component={ProvisionalDetails}
        />
        <PrivateRoute exact path="/add-part" component={AddProduct} />
        <PrivateRoute exact path="/add-product" component={AddProduct} />
        <PrivateRoute exact path="/add-service" component={AddProduct} />
        <PrivateRoute
          exact
          path="/update-part/:urlProductPartId"
          component={AddProduct}
        />
        <PrivateRoute
          exact
          path="/update-product/:urlProductPartId"
          component={AddProduct}
        />
        <PrivateRoute
          exact
          path="/update-service/:urlProductPartId"
          component={AddProduct}
        />
        <PrivateRoute
          exact
          path="/product-stock-entry"
          component={ProductStockEntry}
        />
        <PrivateRoute
          exact
          path="/product-stock-out"
          component={ProductStockOut}
        />
        <PrivateRoute
          exact
          path="/OrderPickingList"
          component={OrderPickingList}
        />

        <PrivateRoute exact path="/my-plan" component={MyPlan} />

        <PrivateRoute exact path="/form-poc" component={FormsPOC} />

        <PrivateRoute exact path="/form-builder" component={FormBuilderPOC} />

        <PrivateRoute exact path="/form-builder2" component={FormBuilderPOC2} />

        <PrivateRoute excat path="/ocr" component={OcrList} />
        <PrivateRoute excat path="/ocr-add" component={OcrForm} />
        <PrivateRoute excat path="/ocr-update/:id" component={OcrForm} />
        <PrivateRoute excat path="/company-list" component={CompanyList} />
        <PrivateRoute excat path="/spire-connect" component={SpireConnect} />
        <PrivateRoute
          excat
          path="/template-builder"
          component={TemplateBuilder}
        />
        <PrivateRoute
          exact
          path="/grapes-template-builder/:id?"
          component={GrapesTemplateBuilder}
        />

        <PrivateRoute
          excat
          path="/invoice-builder/:id?"
          component={GenericTemplateBuilder}
        />
        <PrivateRoute
          excat
          path="/stock-builder/:id?"
          component={GenericTemplateBuilder}
        />
        <PrivateRoute
          excat
          path="/quote-builder/:id?"
          component={GenericTemplateBuilder}
        />
        <PrivateRoute
          excat
          path="/email-builder/:id?"
          component={GenericTemplateBuilder}
        />
        <PrivateRoute
          excat
          path="/checklist-builder/:id?"
          component={GenericTemplateBuilder}
        />

        <PrivateRoute
          excat
          path="/others-builder/:id?"
          component={GenericTemplateBuilder}
        />

        <PrivateRoute
          excat
          path="/Stock-Authorization"
          component={StockAuthorization}
        />

        <PrivateRoute
          excat
          path="/workflow-automation"
          component={WorkflowAutomationDashboard}
        />

        <PrivateRoute
          excat
          path="/add-workflow-automation"
          component={AddWorkflowAutomation}
        />

        <PrivateRoute
          excat
          path="/update-workflow-automation/:id"
          component={AddWorkflowAutomation}
        />

        <PrivateRoute
          excat
          path="/materials-sublist/:id"
          component={MaterialsSubList}
        />

        <PrivateRoute
          excat
          path="/view-materials-sublist/:id"
          component={ViewMaterialsSubList}
        />

        <PrivateRoute excat path="/sales-pipeline" component={ProjectKanban} />
        <PrivateRoute excat path="/activity" component={ShowTimerActivity} />
        <PrivateRoute excat path="/Spire-AI" component={SpireAi} />
        <PrivateRoute
          exact
          path="/Spire-AI-folder/:folderID"
          component={SpireAiUpdate}
        />
        <PrivateRoute exact path="/todolist" component={ToDoList} />
        <PrivateRoute exact path="/notifications" component={Notifications} />
        <PrivateRoute exact path="/expired" component={PaymentExpired} />

        <Route component={PageNotFound} />
      </Switch>
    </>
  );
};

export default React.memo(Routering);
